import type { JsonRpcRequestId, PendingRequest } from './cursor-json-rpc-types.js';

const CURSOR_BRIDGE_METHODS = new Set(['cursor/create_plan', 'cursor/ask_question']);
const CURSOR_NOOP_METHODS = new Set([
  'cursor/update_todos',
  'cursor/task',
  'cursor/generate_image',
]);

export function handleCursorIncomingCursorMethods(
  method: string,
  id: JsonRpcRequestId,
  msg: Record<string, unknown>,
  deps: {
    onRequest?: (request: {
      requestId: string;
      method: string;
      params: Record<string, unknown>;
    }) => void;
    respond: (id: JsonRpcRequestId, result: unknown) => void;
    pendingRequests: Map<JsonRpcRequestId, PendingRequest>;
  },
): boolean {
  if (CURSOR_BRIDGE_METHODS.has(method)) {
    const params = (msg.params as Record<string, unknown> | undefined) ?? {};
    deps.pendingRequests.set(id, { method, params });
    deps.onRequest?.({
      requestId: String(id),
      method,
      params,
    });
    return true;
  }

  if (CURSOR_NOOP_METHODS.has(method)) {
    deps.respond(id, {});
    return true;
  }

  return false;
}
